<div class="uk-container uk-container-expand">
  <div class="uk-grid">
    <div class="uk-width-1-1 uk-margin-small-bottom">
      <h2 class="titre-calendar">Mon Agenda</h2>
    </div>
  </div>
  <div class="uk-grid">
    <div class="uk-width-2-3">
      <ags-planning (dateClicked)="getDateClicked($event)" [staticRequest]="staticRequest"></ags-planning>
    </div>
    <div class="uk-width-1-3">
      <ags-bloc-info [idSP]="idSP" [idIndispo]="idIndispo" [dateClicked]="dateClicked"></ags-bloc-info>
    </div>
  </div>
  <ags-footer-calendar></ags-footer-calendar>
</div>
